export default __webpack_public_path__ + "assets/images/48ba666f85cff5c899ce1d3cf3479b44.svg";